import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { PageHeader } from 'antd';

import Spinner from '../../../components/Spinner';
import StrikeTeamDetailsModel from '../../../models/StrikeTeamDetailsModel';
import { TeamMembersTipsList } from '../../../components/client/TeamsComponents';

const TeamMembersTipsScreen = ({ locStrings, isAdmin }) => {
    const { teamId, clientId } = useParams();
    const modelRef = useRef(null);
    
    const [teamDetails, setTeamDetails] = useState(null);
    const [teamMembersList, setTeamMembersList] = useState(null);
    const [teamMemberLoggedIn, setTeamMemberLoggedIn] = useState(null);
    const [isLoggedInMemberAdmin, setIsLoggedInMemberAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Initialize the model
        modelRef.current = new StrikeTeamDetailsModel({
            viewModel: {
                setTeamDetailsOnPage: (teamDetails, teamMembersList) => {
                    const filteredTeamMember = teamMembersList.filter(member => member.clientId === clientId);
                    const sortedMembers = teamMembersList.sort((a, b) => { 
                        return a.displayName < b.displayName ? -1 : 1 
                    });
                    const teamMemberLoggedIn = filteredTeamMember.length > 0 ? filteredTeamMember[0] : null;
                    const { roles, permissions } = teamMemberLoggedIn || { roles: [], permissions: {} };
                    const isLoggedInMemberAdmin = (roles[0] === 'admin' || permissions.isTeamAdmin);

                    setTeamDetails(teamDetails);
                    setTeamMembersList(sortedMembers);
                    setTeamMemberLoggedIn(teamMemberLoggedIn);
                    setIsLoggedInMemberAdmin(isLoggedInMemberAdmin);
                    setLoading(false);
                },
                setTeamClientDetailsOnPage: (teamClient) => {
                    // This method is called but we don't need to store teamClient in this component
                }
            },
            teamId
        });

        // Start fetching team details
        modelRef.current.waitForTeamDetails({ fetchTeamClient: true });

        // Cleanup function
        return () => {
            if (modelRef.current) {
                modelRef.current.stop();
            }
        };
    }, [teamId, clientId]);

    const isLoading = () => {
        return loading;
    };

    if (!loading && teamDetails && teamMembersList) {
        return (
            <div style={{height: '100%', textAlign: 'center'}}>
                <PageHeader
                    ghost={false}
                    title={`${teamDetails.teamName} - Distributed Tips`}
                    onBack={(() => window.history.back())}
                />
                
                {(isLoggedInMemberAdmin || isAdmin ||
                    (teamMemberLoggedIn && teamMemberLoggedIn.permissions && teamMemberLoggedIn.permissions.canSeeAllTxns))
                && <TeamMembersTipsList
                    condition={() => {
                        return true
                    }}
                    locStrings={locStrings}
                    teamId={teamId}
                    teamDetails={teamDetails}
                    membersList={teamMembersList}
                    currentClientId={clientId}
                    isAdmin={isAdmin}
                />}
            </div>
        );
    } else {
        return (
            <div style={{height: '100%', textAlign: 'center'}}>
                <PageHeader
                    ghost={false}
                    title={`Team Distributed Tips`}
                    onBack={(() => window.history.back())}
                />
                <Spinner condition={() => { return isLoading() }} />
            </div>
        );
    }
};

export default TeamMembersTipsScreen;
